// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"a956e9ba","513":"49e3f393","703":"32a05c89"}[chunkId] + ".chunk.js";
};